export const indicatorlist = [
  {
    id: "ind1",
    tx: 106.4963,
    ty: 713.6191,
    content: "Users",
    arrows: `<path d="M106 712.5H7.47"/>
	  <path d="M0 707.51l8.37 4.99L0 717.49z"/>
	  <path d="M154 711.5h93.53"/>
      <path d="M255 716.49l-8.37-4.99 8.37-4.99z"/>`
  },
  {
    id: "ind2",
    tx: 341.6885,
    ty: 713.6191,
    content: "Sector",
    arrows: `<path d="M340 711.5h-69.53"/>
      <path d="M263 706.51l8.37 4.99-8.37 4.99z"/>
      <path d="M400 711.5h68.53"/>
      <path d="M476 716.49l-8.37-4.99 8.37-4.99z"/>`
  },
  {
    id: "ind3",
    tx: 573.4756,
    ty: 713.6191,
    content: "Cost",
    arrows: `<path d="M573 711.5h-81.53"/>
      <path d="M484 706.51l8.37 4.99-8.37 4.99z"/>
      <path d="M610 711.5h81.53"/>
      <path d="M699 716.49l-8.37-4.99 8.37-4.99z"/>`
  },
  {
    id: "ind4",
    tx: 854.9185,
    ty: 713.6191,
    content: "Spending",
    arrows: `<path d="M854 711.5H714.47"/>
      <path d="M707 706.51l8.37 4.99-8.37 4.99z"/>
      <path d="M929.5 711.5h144.03"/>
      <path d="M1081 716.49l-8.37-4.99 8.37-4.99z"/>`
  }
];
